function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { FormInput } from 'semantic-ui-react';
import { Ref } from "../..";
import Tooltip from "../Tooltip/Tooltip";
import { replaceSpaces, getRest } from "../../utils";
import { jsx as _jsx } from "react/jsx-runtime";
export var DEVISE = {
  EUROS: 'EUR',
  XPF: 'XPF'
};

/**
 * Currency input.
 *
 * @class Currency
 * @extends {React.Component}
 */
var Currency = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Currency, _React$Component);
  /**
     * Creates an instance of Currency.
      * @param {*} args
     * @memberof Currency
     */
  function Currency() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    /**
       * Debounce the changes by 300ms.
       *
       * @memberof Currency
       */
    _this.bouncedChange = _.debounce(function (event, data) {
      _.invoke(_this.props, 'onChange', event, data);
    }, 300);
    /**
     *
     * @memberof Currency
     */
    // eslint-disable-next-line react/no-unused-class-component-methods
    _this.updateValue = function (value) {
      _this.setState({
        value: !_.isNil(value) ? _this.format(value.toString()) : _this.format('')
      });
    };
    /**
       *
       * @memberof Currency
       */
    _this.formatStateValue = function () {
      _this.setState(function (prevState) {
        return {
          value: _this.format(_this.formatBrut(prevState.value))
        };
      });
    };
    /**
       * Handle change input.
       *
       * @memberof Currency
       */
    _this.handleChange = function (e, _ref) {
      var value = _ref.value;
      var event = _.clone(e);
      var _this$props = _this.props,
        precision = _this$props.precision,
        debounced = _this$props.debounced;
      var _this$state = _this.state,
        valueState = _this$state.value,
        pasted = _this$state.pasted;
      var valueSplitted = _.split(value, '.');
      var stateValueSplitted = _.split(valueState, '.');
      var goodValue = value;
      if (pasted) {
        // Si l'on a collé un résultat, on coupe les décimale en trop pour l'afficher
        if (_.size(valueSplitted[1]) > precision) {
          if (precision === 0) {
            goodValue = _.first(valueSplitted);
          } else {
            goodValue = valueSplitted[0] + "." + _.truncate(valueSplitted[1], {
              length: precision,
              omission: ''
            });
          }
        }
        var res = _this.formatBrut(goodValue);
        if (!_.isNil(res)) {
          _this.setState({
            value: res,
            pasted: false
          }, function () {
            if (debounced) {
              _this.bouncedChange(Object.assign({}, e), value);
            } else {
              _.invoke(_this.props, 'onChange', event, value);
            }
          });
        }
      } else {
        var indice = -1;

        // on regarde si ceux sont les décimales qui ont été modifié, pour agir comme un insert
        if (!_.isEqual(valueSplitted[1], stateValueSplitted[1]) && _.size(valueSplitted[1]) > precision) {
          for (var i = 0; i < _.size(valueSplitted[1]); i += 1) {
            if (!_.isEqual(valueSplitted[1][i], stateValueSplitted[1][i]) && !_.isNil(stateValueSplitted[1][i])) {
              indice = i;
              i = _.size(valueSplitted[1]);
            }
          }
          if (indice !== -1) {
            goodValue = valueSplitted[0] + "." + _.join(_.slice(valueSplitted[1], 0, indice + 1), '') + _.join(_.slice(valueSplitted[1], indice + 2, _.size(value)), '');
          }
        }
        var _res = _this.formatBrut(goodValue);
        if (!_.isNil(_res)) {
          _this.setState({
            value: _res
          }, function () {
            if (debounced) {
              _this.bouncedChange(event, _.toNumber(_res));
            } else {
              _.invoke(_this.props, 'onChange', event, _.toNumber(_res));
            }
            _this.handleChangeCursorRef(valueSplitted[0], indice);
          });
        } else if (value === '-' || value === '') {
          _this.setState({
            value: value
          }, function () {
            if (debounced) {
              _this.bouncedChange(event, value);
            } else {
              _.invoke(_this.props, 'onChange', event, value);
            }
            _this.handleChangeCursorRef(valueSplitted[0], indice);
          });
        } else {
          if (debounced) {
            _this.bouncedChange(event, _.toNumber(valueState));
          } else {
            _.invoke(_this.props, 'onChange', event, _.toNumber(valueState));
          }
          _this.handleChangeCursorRef(valueSplitted[0], indice);
        }
      }
    };
    /**
       * Handle change cursor (if we insert decimal)
       *
       * @memberof Currency
       */
    _this.handleChangeCursorRef = function (partieEntiere, indice) {
      var ref = _this.state.ref;
      if (!_.isNil(ref) && indice !== -1) {
        // + 2 car le point du decimal + indice commence a 0
        ref.selectionStart = _.size(partieEntiere) + indice + 2;
        ref.selectionEnd = _.size(partieEntiere) + indice + 2;
      }
    };
    /**
       * Handle focus input.
       *
       * @memberof Currency
       */
    _this.handleFocus = function (e) {
      var event = _.clone(e);
      _this.setState(function (state) {
        return {
          value: _this.formatBrut(state.value)
        };
      }, function () {
        var _this$state2 = _this.state,
          ref = _this$state2.ref,
          value = _this$state2.value;
        if (!_.isNil(ref) && !_.isNil(value)) {
          ref.setSelectionRange(0, value.length);
        }
        _.invoke(_this.props, 'onFocus', event, value);
      });
    };
    _this.getCurrentDeviseLabel = function () {
      var _this$props2 = _this.props,
        devise = _this$props2.devise,
        currency = _this$props2.currency;
      if (!devise) {
        return '';
      }
      switch (currency) {
        case DEVISE.EUROS:
          return '€';
        case DEVISE.XPF:
          return 'FCFP';
        default:
          return '';
      }
    };
    /**
       * Handle blur input.
       *
       * @memberof Currency
       */
    _this.handleBlur = function (e) {
      /* On clone l'evenement pour pouvoir le passer a la callback du setState */
      var event = _.clone(e);
      var _this$props3 = _this.props,
        debounced = _this$props3.debounced,
        percent = _this$props3.percent,
        percentMin = _this$props3.percentMin,
        percentMax = _this$props3.percentMax,
        valueMin = _this$props3.valueMin,
        valueMax = _this$props3.valueMax,
        currency = _this$props3.currency;
      var valueState = _this.state.value;
      var message = null;
      if (percent) {
        if (_.toNumber(valueState) < percentMin) {
          message = "Taux inf\xE9rieur au taux minimum autoris\xE9. (" + percentMin + "%)";
        }
        if (_.toNumber(valueState) > percentMax) {
          message = "Taux sup\xE9rieur au taux maximum autoris\xE9. (" + percentMax + "%)";
        }
      } else {
        if (_.toNumber(valueState) < valueMin) {
          message = "Valeur inf\xE9rieure \xE0 la valeur minimum autoris\xE9e. (" + valueMin + _this.getCurrentDeviseLabel() + ")";
        }
        if (_.toNumber(valueState) > valueMax) {
          message = "Valeur sup\xE9rieure \xE0 la valeur maximum autoris\xE9e. (" + valueMax + _this.getCurrentDeviseLabel() + ")";
        }
      }
      _this.setState(function (state) {
        return {
          value: _this.format(_this.formatBrut(state.value)),
          error: message
        };
      }, function () {
        var value = _this.state.value;
        if (debounced) {
          if (_this.bouncedChange) {
            _this.bouncedChange.flush();
          }
        }
        _.invoke(_this.props, 'onBlur', event, _.toNumber(_this.formatBrut(value)));
      });
    };
    /**
       * Handle key down.
       *
       * @memberof Currency
       */
    _this.handleKeyDown = function (e) {
      var ref = _this.state.ref;
      var _ref2 = e || {},
        key = _ref2.key;
      if (key === 'Enter' && !_.isNil(ref)) {
        ref.blur();
      }
    };
    /**
       * Format with Euro sign.
       *
       * @memberof Currency
       */
    _this.format = function (value) {
      var _this$props4 = _this.props,
        precision = _this$props4.precision,
        devise = _this$props4.devise,
        currency = _this$props4.currency,
        percent = _this$props4.percent;
      var options = {};
      if (percent) {
        options = {
          style: 'percent',
          maximumFractionDigits: precision
        };
      } else if (devise) {
        if (currency === DEVISE.EUROS) {
          options = {
            style: 'currency',
            currency: DEVISE.EUROS,
            maximumFractionDigits: precision,
            minimumFractionDigits: precision
          };
        } else {
          options = {
            style: 'currency',
            currency: DEVISE.XPF
          };
        }
      } else {
        options = {
          style: 'decimal',
          maximumFractionDigits: precision,
          minimumFractionDigits: precision
        };
      }
      if (value === '') {
        return '';
      }
      var formatedValue = new Intl.NumberFormat('fr-FR', Object.assign({}, options)).format(percent ? value / 100 : value);
      return replaceSpaces(formatedValue);
    };
    /**
       * Format brut.
       *
       * @memberof Currency
       */
    _this.formatBrut = function (value) {
      var _this$props5 = _this.props,
        precision = _this$props5.precision,
        currency = _this$props5.currency;
      var valueFormat = _.replace(value, ',', '.');
      valueFormat = _.replace(valueFormat, '€', '');
      valueFormat = _.replace(valueFormat, 'FCFP', '');
      valueFormat = _.replace(valueFormat, '%', '');
      var space = '32';
      var char4 = String.fromCharCode(space);
      var re4 = new RegExp("" + char4, 'g');
      valueFormat = _.replace(valueFormat, re4, '');

      // Ne pas toucher cette partie, elle remplace les caractères généré par la fonction numberFormat
      valueFormat = replaceSpaces(valueFormat);
      var regexp = precision > 0 ? new RegExp("^-{0,1}[0-9]+((\\.|\\,)[0-9]{0," + precision + "})?$", 'gm')
      // eslint-disable-next-line prefer-regex-literals
      : new RegExp('^-?[0-9]+$', 'gm');

      // eslint-disable-next-line prefer-regex-literals
      var regexpFranc = new RegExp('^-{0,1}[0-9]+?$', 'gm');
      if (currency === DEVISE.XPF) {
        if (regexpFranc.test(valueFormat)) {
          return valueFormat;
        }
      } else if (regexp.test(valueFormat)) {
        return valueFormat;
      }
      return null;
    };
    /**
       * Handle reference input.
       *
       * @memberof Currency
       */
    _this.handleRef = function (node) {
      if (!_.isNil(node)) {
        if (!_.isEmpty(node.getElementsByClassName('input'))) {
          _this.setState({
            ref: node.getElementsByClassName('input')[0].firstChild
          });
        } else {
          _this.setState({
            ref: null
          });
        }
      } else {
        _this.setState({
          ref: null
        });
      }
    };
    /**
       * Handle paste in field.
       *
       * @memberof Currency
       */
    _this.handlePaste = function () {
      return _this.setState({
        pasted: true
      });
    };
    var _value = _this.props.value;
    _this.state = {
      /** Value. */
      value: !_.isNil(_value) ? _this.format(_value.toString()) : _this.format('0'),
      /** Reference. */
      ref: null,
      /** Error. */
      error: null,
      /** Pasted ? */
      pasted: false
    };
    return _this;
  }

  /**
     * Component did update.
     *
     * @param {*} prevProps
     * @memberof Currency
     */
  var _proto = Currency.prototype;
  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var _this$props6 = this.props,
      currency = _this$props6.currency,
      devise = _this$props6.devise,
      percent = _this$props6.percent;
    var prevCurrency = prevProps.currency,
      prevDevise = prevProps.devise,
      prevPercent = prevProps.percent,
      prevValue = prevProps.value;
    this.updateStateOnPropsChange(prevValue);
    if (!_.isEqual(currency, prevCurrency) || !_.isEqual(devise, prevDevise) || !_.isEqual(percent, prevPercent)) {
      this.formatStateValue();
    }
  };
  /**
     * Handle update when value props change
     *
     * @memberof Currency
     */
  _proto.updateStateOnPropsChange = function updateStateOnPropsChange(prevValue) {
    var value = this.props.value;
    var stateValue = this.state.value;
    if (!_.isEqual(value, prevValue)) {
      if (!_.isEqual(this.formatBrut(value), this.formatBrut(stateValue))) {
        this.setState({
          value: !_.isNil(value) ? this.format(value.toString()) : this.format('')
        });
      }
    }
  }

  /**
     * Render the component.
     *
     * @returns
     * @memberof Currency
     */;
  _proto.render = function render() {
    var description = this.props.description;
    var _this$state3 = this.state,
      value = _this$state3.value,
      error = _this$state3.error;
    var rest = getRest(Currency, this.props);
    var optionsPopup = !_.isNil(error) ? {
      type: 'error',
      message: error,
      description: description
    } : {
      description: description
    };
    return /*#__PURE__*/_jsx(Ref, {
      innerRef: this.handleRef,
      children: !_.isNil(description) && !_.isNil(error) ? /*#__PURE__*/_jsx(Tooltip, Object.assign({}, optionsPopup, {
        position: "bottom right",
        trigger: /*#__PURE__*/_jsx(FormInput, Object.assign({}, rest, {
          value: value,
          onChange: this.handleChange,
          onBlur: this.handleBlur,
          onFocus: this.handleFocus,
          onPaste: this.handlePaste,
          onKeyDown: this.handleKeyDown,
          input: /*#__PURE__*/_jsx("input", {
            style: {
              textAlign: 'right'
            }
          })
        }))
      })) : /*#__PURE__*/_jsx(FormInput, Object.assign({}, rest, {
        value: value,
        onChange: this.handleChange,
        onBlur: this.handleBlur,
        onPaste: this.handlePaste,
        onFocus: this.handleFocus,
        onKeyDown: this.handleKeyDown,
        input: /*#__PURE__*/_jsx("input", {
          style: {
            textAlign: 'right'
          }
        })
      }))
    });
  };
  return Currency;
}(React.Component);
/**
 * Prop types.
 */
Currency.handledProps = ["currency", "debounced", "description", "devise", "onBlur", "onChange", "onFocus", "percent", "percentMax", "percentMin", "precision", "value", "valueMax", "valueMin"];
Currency.propTypes = {
  /** Value. */
  value: PropTypes.number.isRequired,
  /** Number of decimal display. */
  precision: PropTypes.number,
  /** If the devise is displayed. */
  devise: PropTypes.bool,
  /** If the field is percent. */
  percent: PropTypes.bool,
  /** Callback on change. */
  onChange: PropTypes.func,
  /** Callback on blur. */
  onBlur: PropTypes.func,
  /** Callback on focus. */
  onFocus: PropTypes.func,
  /** Currency. */
  currency: PropTypes.oneOf([DEVISE.EUROS, DEVISE.XPF]),
  /** Percentage minimum allowed. */
  percentMin: PropTypes.number,
  /** Percentage maximum allowed. */
  percentMax: PropTypes.number,
  /** Value minimum allowed. */
  valueMin: PropTypes.number,
  /** Value maximum allowed. */
  valueMax: PropTypes.number,
  /** Description. */
  description: PropTypes.string,
  /** Whether or not the changes are debounced. */
  debounced: PropTypes.bool
};

/**
 * Default props.
 */
Currency.defaultProps = {
  precision: 2,
  devise: false,
  currency: DEVISE.EUROS,
  debounced: true
};
export default Currency;